import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight, ExternalLink } from "lucide-react";
import LinkWrapper from "../Common/LinkWrapper";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
const Menu = ({ children }) => {
    return _jsx("div", { className: "flex flex-col gap-3", children: children });
};
const Group = ({ children }) => {
    return (_jsx("div", { children: _jsx("div", { className: "divide-y divide-secondary-300 rounded-xl bg-secondary-500 overflow-hidden", children: children }) }));
};
const Item = (function Item({ children, pathname, onClick, icon, target = '_self' }) {
    return (_jsx(_Fragment, { children: pathname ?
            _jsxs(LinkWrapper, { href: pathname, target: target, className: "gap-4 flex relative cursor-pointer hover:bg-secondary-400 select-none w-full items-center px-4 py-3 outline-hidden text-primary-text", children: [_jsx("div", { children: icon }), _jsx("p", { className: "text-primary-text", children: children }), target === '_self' ?
                        _jsx(ChevronRight, { className: "h-4 w-4 absolute right-3" })
                        :
                            _jsx(ExternalLink, { className: "h-4 w-4 absolute right-3" })] })
            :
                _jsxs("button", { type: "button", onClick: onClick, className: `gap-4 flex relative cursor-pointer hover:bg-secondary-400 select-none items-center px-4 py-3 outline-hidden w-full text-primary-text`, children: [_jsx("div", { children: icon }), _jsx("p", { className: "text-primary-text", children: children }), _jsx(ChevronRight, { className: "h-4 w-4 absolute right-3" })] }) }));
});
export var ItemType;
(function (ItemType) {
    ItemType["button"] = "button";
    ItemType["link"] = "link";
})(ItemType || (ItemType = {}));
const variants = {
    enter: () => {
        return ({
            opacity: 0,
            y: '100%',
        });
    },
    center: () => {
        return ({
            opacity: 1,
            y: 0,
        });
    },
    exit: () => {
        return ({
            y: '100%',
            zIndex: 0,
            opacity: 0,
        });
    },
};
const Footer = ({ children, hidden, sticky = true }) => {
    const [height, setHeight] = useState(0);
    const ref = useRef(null);
    useEffect(() => {
        setHeight(Number(ref?.current?.clientHeight));
    }, []);
    const handleAnimationEnd = (variant) => {
        if (variant == "center") {
            setHeight(Number(ref?.current?.clientHeight));
        }
    };
    return (sticky ?
        _jsxs(_Fragment, { children: [_jsx(motion.div, { onAnimationComplete: handleAnimationEnd, ref: ref, transition: {
                        duration: 0.15,
                    }, custom: { direction: -1, width: 100 }, variants: variants, className: `border-t border-secondary-500 text-primary-text text-base mt-3        
                        fixed
                        inset-x-0
                        bottom-0 
                        z-30
                        bg-secondary-700 
                        shadow-widget-footer 
                        p-4 
                        pr-6
                        pl-5 
                        w-full ${hidden ? 'animation-slide-out' : ''}`, children: children }), _jsx("div", { style: { height: `${height}px` }, className: `text-primary-text text-base        
                             inset-x-0
                             bottom-0 
                             p-4 w-full invisible` })] })
        :
            _jsx(_Fragment, { children: children }));
};
Menu.Group = Group;
Menu.Item = Item;
Menu.Footer = Footer;
export default Menu;
